import { useRef, useState } from "react";
import { PageCanvas } from "@/components/page-canvas";
import { Form, Head, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Content from "./content";
import type { Review } from "./types";
import { Errors } from "../requests/controls";
export default function View({
  review,
  decision_url,
}: {
  review: Review;
  decision_url: string;
}) {
  const { t } = useTranslation();
  const { customer_history_path } = usePage<{
    customer_history_path?: string;
  }>().props;
  const trigger = useRef<HTMLButtonElement>(null);
  const [declining, setDeclining] = useState(false);
  return (
    <PageCanvas as="main">
      {customer_history_path && (
        <Link className="inline-block underline" href={customer_history_path}>
          {t("customer_portal.history")}
        </Link>
      )}
      <Head title={t("billing_reviews.title")} />
      <Errors />
      <Content review={review} />
      <p role="status">{t(`billing_reviews.states.${review.state}`)}</p>
      {review.writable && (
        <Form
          action={decision_url}
          method="post"
          className="flex flex-wrap gap-3"
        >
          {({ processing }) => (
            <>
              <input type="hidden" name="revision" value={review.revision} />
              <Button
                type="submit"
                name="decision[action]"
                value="approved"
                disabled={processing}
              >
                {t("billing_reviews.approve")}
              </Button>
              <Button
                ref={trigger}
                variant="outline"
                type="button"
                aria-expanded={declining}
                aria-controls="billing-secondary-declined"
                onClick={() => setDeclining(true)}
              >
                {t("proposals.decline")}
              </Button>
              {declining && (
                <div
                  id="billing-secondary-declined"
                  className="w-full space-y-3 rounded-lg border p-4"
                >
                  <p id="billing-decline-help">
                    {t("workflow.decline_review")}
                  </p>
                  <div className="flex gap-3">
                    <Button
                      autoFocus
                      aria-describedby="billing-decline-help"
                      variant="outline"
                      type="submit"
                      name="decision[action]"
                      value="declined"
                      disabled={processing}
                    >
                      {t("proposals.decline")}
                    </Button>
                    <Button
                      variant="ghost"
                      type="button"
                      onClick={() => {
                        setDeclining(false);
                        trigger.current?.focus();
                      }}
                    >
                      {t("common.cancel")}
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </Form>
      )}
      {!review.current && review.state !== "confirmed" && (
        <p role="alert">{t("billing_reviews.stale")}</p>
      )}
    </PageCanvas>
  );
}
